<div class="chat-row" [class.user-typed]="data.key === key">    
    <div class="chat-message-wrap">
        <div class="chat-message-container">
            <div class="chat-message-border">
                <span class="chat-message-text">{{data.message}}</span>
                <span class="chat-message-date">{{data.time}}</span>
            </div>
        </div>
    </div>
</div>